import { Group, Pagination, Skeleton, Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useArtists } from '~/api/queries'
import { ArtistGrid } from '~/components/blocks/ArtistGrid/ArtistGrid'

export const Route = createFileRoute('/_app/artists/')({
  component: ArtistsPage,
})

function ArtistsPage() {
  const [page, setPage] = useState(1)
  const limit = 30
  const { data, isLoading } = useArtists({ limit, offset: (page - 1) * limit })

  const totalPages = data ? Math.ceil(data.total / limit) : 0

  return (
    <Stack gap="md">
      <Title order={2}>Artists</Title>

      {isLoading ? <Skeleton h={400} /> : data?.data ? <ArtistGrid artists={data.data} /> : null}

      {totalPages > 1 && (
        <Group justify="center">
          <Pagination value={page} onChange={setPage} total={totalPages} />
        </Group>
      )}
    </Stack>
  )
}
